var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-tooltip',{attrs:{"top":_vm.alignTop,"bottom":_vm.alignBottom,"left":_vm.alignLeft,"right":_vm.alignRight,"max-width":"192px","disabled":_vm.disabled,"variant":_vm.variant},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({style:(_vm.fitContentClass)},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }